import React from 'react';
import { IonPage } from '@ionic/react';
import { useShareWizardContext } from '@/contexts/ShareWizardContext';
import { ShareNavigationLogic } from './navigation_logic';
import ShareWizardHeader from './ShareWizardHeader';

interface GardenSharePageProps {
  /** The destination's own title, shown in the toolbar. */
  title: string;
  children: React.ReactNode;
}

/**
 * The frame each garden destination renders itself in: the routed page, and the
 * toolbar carrying the way back and the way out.
 *
 * The back arrow appears only where there is somewhere to go back to, which is
 * what the sequence answers — the first destination has none, and so does one
 * the session has dropped out of. Leaving by the X is the session's own rule
 * and lives in the header, so a destination never restates it.
 */
const GardenSharePage: React.FC<GardenSharePageProps> = ({
  title,
  children,
}) => {
  const { topic, nav } = useShareWizardContext();
  const hasSomewhereBack =
    ShareNavigationLogic.before(nav.sequence, nav.at) !== null;

  return (
    <IonPage>
      <ShareWizardHeader
        topicTitle={topic?.title ?? ''}
        title={title}
        progress={nav.progress}
        onBack={hasSomewhereBack ? nav.goBack : undefined}
      />
      {children}
    </IonPage>
  );
};

export default GardenSharePage;
